var map = {
	"./bell.png": 4836,
	"./books.png": 8363,
	"./calendar.png": 4350,
	"./cross.png": 3399,
	"./edit.png": 4317,
	"./hand.png": 949,
	"./late.png": 1758,
	"./messageCallout.png": 4805,
	"./school.png": 5176,
	"./sick.png": 308,
	"./star.png": 6426,
	"./student.png": 5509,
	"./teacher.png": 4369,
	"./time.png": 1857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6344;